import { CrudService, EntityProps } from '@awp/shared/CrudService';
import React from 'react';

export default class SoilProfileService extends CrudService {
  getActionMenu(event: any): React.ReactElement {
    return <></>;
  }

  getColumns(props: any): any {
    const { soilTypeCell, depthCell, actionsCell, ...rest } = props;

    const columns: any[] = [
      {
        Header: 'Soil Type',
        accessor: 'SoilTypeId',
        style: { width: '300px' },
        Cell: soilTypeCell,
        sortType: 'alphanumeric',
      },
      {
        Header: 'Start Depth (cm)',
        accessor: 'TopmostRelativeElevation',
        style: { width: '150px' },
        Cell: depthCell
          ? depthCell
          : (row: any) => {
              const cell = row?.row?.original;
              return <span>{cell?.TopmostRelativeElevation}</span>;
            },
        sortType: 'alphanumeric',
      },
    ];

    if (actionsCell) {
      columns.push({
        Header: '',
        accessor: 'actions',
        style: { width: '100px' },
        Cell: actionsCell,
        disableSortBy: true,
      });
    }

    return columns;
  }

  getFields(props: any): React.ReactElement {
    return <></>;
  }

  getValidations(props?: any): any {
    /* Do Nothing */
  }

  mapFormToDTO(props: any): any {
    /* Do Nothing */
  }

  mapInitialValues(props: any): any {
    const { entity, ...rest } = props;
    return entity;
  }

  cleanFormValues(props: EntityProps): any {
    /* Do Nothing */
  }
}
